export const workEnvironment = {
  junior: {
    macos: [
      { step: 'Install Homebrew', command: '/bin/bash -c "$(curl -fsSL https://raw.githubusercontent.com/Homebrew/install/HEAD/install.sh)"' },
      { step: 'Install Chrome', command: 'brew install --cask google-chrome' },
      { step: 'Install Firefox', command: 'brew install --cask firefox' },
      { step: 'Install Postman', command: 'brew install --cask postman' },
      { step: 'Install VS Code', command: 'brew install --cask visual-studio-code' },
      { step: 'Install Node.js', command: 'brew install node' },
      { step: 'Install Python', command: 'brew install python' }
    ],
    windows: [
      { step: 'Install Chocolatey', command: 'Set-ExecutionPolicy Bypass -Scope Process -Force; [System.Net.ServicePointManager]::SecurityProtocol = [System.Net.ServicePointManager]::SecurityProtocol -bor 3072; iex ((New-Object System.Net.WebClient).DownloadString(\'https://community.chocolatey.org/install.ps1\'))' },
      { step: 'Install Chrome', command: 'choco install googlechrome' },
      { step: 'Install Firefox', command: 'choco install firefox' },
      { step: 'Install Postman', command: 'choco install postman' },
      { step: 'Install VS Code', command: 'choco install vscode' },
      { step: 'Install Node.js', command: 'choco install nodejs' },
      { step: 'Install Python', command: 'choco install python' }
    ],
    linux: [
      { step: 'Update package manager', command: 'sudo apt update && sudo apt upgrade -y' },
      { step: 'Install Chrome', command: 'wget -q -O - https://dl.google.com/linux/linux_signing_key.pub | sudo apt-key add - && echo "deb [arch=amd64] http://dl.google.com/linux/chrome/deb/ stable main" | sudo tee /etc/apt/sources.list.d/google-chrome.list && sudo apt update && sudo apt install google-chrome-stable' },
      { step: 'Install Firefox', command: 'sudo apt install firefox' },
      { step: 'Install VS Code', command: 'wget -qO- https://packages.microsoft.com/keys/microsoft.asc | gpg --dearmor > packages.microsoft.gpg && sudo install -o root -g root -m 644 packages.microsoft.gpg /etc/apt/trusted.gpg.d/ && sudo sh -c \'echo "deb [arch=amd64,arm64,armhf signed-by=/etc/apt/trusted.gpg.d/packages.microsoft.gpg] https://packages.microsoft.com/repos/code stable main" > /etc/apt/sources.list.d/vscode.list\' && sudo apt update && sudo apt install code' },
      { step: 'Install Node.js', command: 'curl -fsSL https://deb.nodesource.com/setup_lts.x | sudo -E bash - && sudo apt-get install -y nodejs' },
      { step: 'Install Python', command: 'sudo apt install python3 python3-pip' }
    ]
  },
  mid: {
    macos: [
      { step: 'Install Selenium WebDriver', command: 'npm install -g selenium-webdriver' },
      { step: 'Install Cypress', command: 'npm install -g cypress' },
      { step: 'Install JMeter', command: 'brew install jmeter' },
      { step: 'Install Appium', command: 'npm install -g appium' },
      { step: 'Install Docker Desktop', command: 'brew install --cask docker' },
      { step: 'Install TestRail CLI', command: 'pip3 install testrail-api' }
    ],
    windows: [
      { step: 'Install Selenium WebDriver', command: 'npm install -g selenium-webdriver' },
      { step: 'Install Cypress', command: 'npm install -g cypress' },
      { step: 'Install JMeter', command: 'choco install jmeter' },
      { step: 'Install Appium', command: 'npm install -g appium' },
      { step: 'Install Docker Desktop', command: 'choco install docker-desktop' },
      { step: 'Install Azure DevOps CLI', command: 'az extension add --name azure-devops' }
    ],
    linux: [
      { step: 'Install Selenium WebDriver', command: 'npm install -g selenium-webdriver' },
      { step: 'Install Cypress', command: 'npm install -g cypress' },
      { step: 'Install JMeter', command: 'sudo apt install jmeter' },
      { step: 'Install Appium', command: 'npm install -g appium' },
      { step: 'Install Docker', command: 'curl -fsSL https://get.docker.com -o get-docker.sh && sh get-docker.sh' },
      { step: 'Install Jenkins', command: 'wget -q -O - https://pkg.jenkins.io/debian-stable/jenkins.io.key | sudo apt-key add - && sudo sh -c \'echo deb https://pkg.jenkins.io/debian-stable binary/ > /etc/apt/sources.list.d/jenkins.list\' && sudo apt-get update && sudo apt-get install jenkins' }
    ]
  },
  senior: {
    macos: [
      { step: 'Install K6 Load Testing', command: 'brew install k6' },
      { step: 'Install Lighthouse CI', command: 'npm install -g @lhci/cli' },
      { step: 'Install Allure Report', command: 'brew install allure' },
      { step: 'Install Chaos Monkey', command: 'brew install chaosmonkey' },
      { step: 'Install Grafana', command: 'brew install grafana' }
    ],
    windows: [
      { step: 'Install K6 Load Testing', command: 'choco install k6' },
      { step: 'Install Lighthouse CI', command: 'npm install -g @lhci/cli' },
      { step: 'Install Allure Report', command: 'choco install allure' },
      { step: 'Install Azure Load Testing', command: 'az extension add --name load' },
      { step: 'Install Power BI Desktop', command: 'choco install powerbi' }
    ],
    linux: [
      { step: 'Install K6 Load Testing', command: 'sudo apt-key adv --keyserver hkp://keyserver.ubuntu.com:80 --recv-keys C5AD17C747E3415A3642D57D77C6C491D6AC1D69 && echo "deb https://dl.k6.io/deb stable main" | sudo tee /etc/apt/sources.list.d/k6.list && sudo apt-get update && sudo apt-get install k6' },
      { step: 'Install Lighthouse CI', command: 'npm install -g @lhci/cli' },
      { step: 'Install Allure Report', command: 'sudo apt install allure' },
      { step: 'Install Prometheus', command: 'wget https://github.com/prometheus/prometheus/releases/download/v2.40.0/prometheus-2.40.0.linux-amd64.tar.gz && tar xvfz prometheus-*.tar.gz && sudo mv prometheus-*/prometheus /usr/local/bin/' },
      { step: 'Install ELK Stack', command: 'docker run -p 5601:5601 -p 9200:9200 -p 5044:5044 -it --name elk sebp/elk' }
    ]
  }
};
